import classNames from 'classnames';
import React from 'react';
import './loading-bar.scss';

export enum LoadingBarType {
  'loading' = 0,
  'progress' = 1,
}

interface LoadingBarProps {
  complete: number; // in percentage
  type?: LoadingBarType;
}

export const LoadingBar: React.FunctionComponent<LoadingBarProps> = ({ complete, type }) => {
  return (
    <div className={classNames('loading-bar', { 'loading-bar-progress': type === LoadingBarType.progress })}>
      <div
        className={classNames('loading-bar__loaded', {
          'loading-bar__loaded-progress': type === LoadingBarType.progress,
        })}
        style={{ width: `${complete}%` }}
      />
    </div>
  );
};
